import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../hooks/hooks";
import Table from "../../../../common/components/table";
import PageLoader from "../../../../components/PageLoader";
import { useNavigate } from "react-router-dom";
import { selectGlobalDBNPRegistrationsListItems } from "../../../../redux/global-dbnp-registrations/selector";
import { globalDBNPRegistrations } from "../../../../redux/global-dbnp-registrations/action";
import * as R from "ramda"
import storePersist from "../../../../redux/storePersist";



const GlobalDBNPRegistrations = () => {
  const librariesItems = storePersist?.get("library")?.current;
  localStorage.removeItem('storageKey')
	const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
    const globalDBNPRegistrationsItems = useSelector(selectGlobalDBNPRegistrationsListItems)
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          { field: 'DBNIEName', headerName: 'DBNIE Name'},
          { field: 'DBNPName', headerName: 'DBNP Name'},
          { field: 'DBNPRegistryTypeId', headerName: 'DBNP Registry Type',valueFormatter: getDbnpRegistryName},
          { field: 'name_of_authorised_signatory', headerName: 'DBNP Registry Name',searchField: 'name_of_authorised_signatory', filter: true,
            filterType: 'text'},
          { field: 'email_id', headerName: 'Email',searchField: 'email_id', filter: true,
            filterType: 'text'},
          { field: 'mobile_no', headerName: 'Mobile No',searchField: 'mobile_no', filter: true,
            filterType: 'text'},
          { field: 'country', headerName: 'country',searchField: 'country', filter: true,
            filterType: 'text'},
          // { headerName: 'subscribe', isGlobalDBNPRegistry: true }  
        ]);
      }


      const handleSearch = (data: any) => {
        console.log('Search data', data)
        let searchCriteria = {};
        if (data?.column){
          searchCriteria = [{
            FieldName: data?.column,
            FieldText: data?.column,
            FieldType: 'text',
            FilterOperatorId: 6,
            FieldValue: data?.value
          }]
        } else {
          searchCriteria = [{
            FieldName: "Name",
            FieldText: "Name",
            FieldType: 'text',
            FilterOperatorId: 6,
            FieldValue: data?.value
          }]
        }
    
        dispatch(globalDBNPRegistrations.list({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-dbnp-registrations/list`,entity:'globalDBNPRegistrations',jsonData:{
      
          "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "Id",
          "SortOrder": "desc",
          "Searches": searchCriteria,
      
          }}))
      }
    
      

      const handleReloadData = () => {
        dispatch(globalDBNPRegistrations.list({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-dbnp-registrations/list`,entity:'globalDBNPRegistrations',jsonData:{
      
          "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "Id",
          "SortOrder": "desc",
      
          }}))
      }
      const filterTypes = [{
        name: 'Text', value: "text"
      },
      {
        name: 'Number', value: "number"
      },
      {
        name: 'CheckBox', value: "checkbox"
      },
      {
        name: 'Date', value: "date"
      }
      ]
      const getDbnpRegistryName = (storeNameId: any) => {
        const StoreNameList = R.find(
          (storeName: any) => parseInt(
            storeName.Value,
            10
          ) === parseInt(
            storeNameId,
            10
          ),
          librariesItems?.DBNPRegistryType
        )
        return StoreNameList ? StoreNameList.Description : ''
      }
      const handleSubscribeForOpenNetwork = async (data: any) => {
        dispatch(globalDBNPRegistrations.create({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/organization/dbn/open-network-subscriptions/subscribe`,entity:'globalDBNPRegistrations',jsonData:{
       
        Records: [
          { 
            "Message": {
              Id: data?.DBNPRegistryId,
            }
        } 
        ]
    }})).then(() => {
      dispatch(globalDBNPRegistrations.list({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-dbnp-registrations/list`,entity:'globalDBNPRegistrations',jsonData:{
      
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
    
        }}))

      })
    }
      const fetchGlobalDBNPRegistrations=()=>{
        dispatch(globalDBNPRegistrations.list({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-dbnp-registrations/list`,entity:'globalDBNPRegistrations',jsonData:{
      
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        
    
        }}))
      }
      const handleAdd=()=>{
        navigate(`${0}`)
      }
      const handleEdit=(data: any)=>{
       navigate(`${data.Id}`)
      }
      const additionButtons: any = [
        {
          svg:
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload</title>
          <path d="M20.0092 2V5.13219C20.0092 5.42605 19.6418 5.55908 19.4537 5.33333C17.6226 3.2875 14.9617 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
        // name: 'Reload',
        callback: () => handleReloadData(),
        },
      ];

	useEffect(() => {
        createColumnDefs()
        fetchGlobalDBNPRegistrations()
	}, [pageData,pageSize])

  const handleDelete=(data: any)=>{
    dispatch(globalDBNPRegistrations.delete({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-dbnp-registrations/delete`,
      entity: 'globalDBNPRegistrations',
      jsonData: {
        Records: [
          {
         
                Id: data?.Id
            }
          
        ]
      }
  })).then(() => {
    dispatch(globalDBNPRegistrations.list({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-dbnp-registrations/list`,entity:'globalDBNPRegistrations',jsonData:{
  
    "PageNumber": pageData,
    "PageSize": pageSize,
    "SortField": "Id",
    "SortOrder": "desc",
    

    }}))
  });
  }
	return (
    <>
    {globalDBNPRegistrationsItems?.isLoading ?  <PageLoader />: 
		<Table columnData={columnDefs}enableFilter={true}additionButtons={additionButtons}
    filterTypeLists={filterTypes}
    onSearch={handleSearch} rowData={globalDBNPRegistrationsItems?.result?.items} setPageData={setPageData}
    paginationData={globalDBNPRegistrationsItems?.result?.pagination} handleSubscribeForOpenNetwork={handleSubscribeForOpenNetwork} 
    onEdit={handleEdit} onDelete={handleDelete}  setPageSize={setPageSize}headingName="Global DBNP Registrations"/>
     
  }
  </> 
	);
};

export default GlobalDBNPRegistrations;


